/** Dev-only — temp header button style preview (not product). */

export const HEADER_BTN_PREVIEW_KEY = 'qc-header-btn-preview';
export const HEADER_BTN_PREVIEW_EVENT = 'qc-header-btn-preview-change';

export function getHeaderButtonPreview(): string | null {
  if (typeof window === 'undefined') return null;
  return sessionStorage.getItem(HEADER_BTN_PREVIEW_KEY);
}

export function setHeaderButtonPreview(variantId: string): void {
  sessionStorage.setItem(HEADER_BTN_PREVIEW_KEY, variantId);
  document.documentElement.dataset.qcHeaderBtnPreview = variantId;
  window.dispatchEvent(
    new CustomEvent(HEADER_BTN_PREVIEW_EVENT, { detail: variantId }),
  );
}

export function clearHeaderButtonPreview(): void {
  sessionStorage.removeItem(HEADER_BTN_PREVIEW_KEY);
  delete document.documentElement.dataset.qcHeaderBtnPreview;
  window.dispatchEvent(
    new CustomEvent(HEADER_BTN_PREVIEW_EVENT, { detail: null }),
  );
}

export function syncHeaderButtonPreviewDataset(): void {
  const variant = getHeaderButtonPreview();
  if (variant) {
    document.documentElement.dataset.qcHeaderBtnPreview = variant;
  } else {
    delete document.documentElement.dataset.qcHeaderBtnPreview;
  }
}
